import { memo, useCallback, useEffect, useMemo } from 'react'

import { MenuItem } from '@mui/material'

import { Select } from '@collaborate-health/uikit'
import { useDispatch, useSelector } from '@tabeeb/store'

import {
  getFormUsersFilterSelectedValue,
  getIsFormUsersFilterVisible,
  selectUsersFilter,
} from '@tabeeb/modules/forms/selectors'
import { setDisplayAnswersMode, setSelectedUserId } from '@tabeeb/modules/forms/actions'

import { DisplayAnswersMode } from '../../enums'

export interface UsersFilterProps {
  disabled?: boolean
}

const UsersFilter: React.FC<UsersFilterProps> = ({ disabled = false }) => {
  const dispatch = useDispatch()

  const value = useSelector(getFormUsersFilterSelectedValue)
  const users = useSelector(selectUsersFilter)
  const isVisible = useSelector(getIsFormUsersFilterVisible)

  useEffect(() => {
    if (!isVisible) {
      dispatch(setDisplayAnswersMode(DisplayAnswersMode.AllLatest))
    }
  }, [dispatch, isVisible])

  const onChange = useCallback(
    (event) => {
      let displayAnswersMode
      let userId = 0

      switch (event.target.value) {
        case 'allLatest':
          displayAnswersMode = DisplayAnswersMode.AllLatest
          break
        case 'allMyLatest':
          displayAnswersMode = DisplayAnswersMode.AllMyLatest
          break
        default:
          displayAnswersMode = DisplayAnswersMode.ByUser
          userId = parseInt(event.target.value, 10)
          dispatch(setSelectedUserId(userId))
          break
      }

      dispatch(setDisplayAnswersMode(displayAnswersMode))
    },
    [dispatch]
  )

  const title = useMemo(() => {
    switch (value) {
      case 'allLatest':
        return 'All latest'
      case 'allMyLatest':
        return 'All my latest'
      default:
        return users.find((u) => u.id === value)?.displayName ?? ''
    }
  }, [users, value])

  if (!isVisible) {
    return null
  }

  return (
    <Select disabled={disabled} size='small' value={value} label='User' title={title} fullWidth onChange={onChange}>
      <MenuItem key='all_latest' value='allLatest' title='All latest'>
        All latest
      </MenuItem>
      <MenuItem key='my_latest' value='allMyLatest' title='All my latest'>
        All my latest
      </MenuItem>
      {(users ?? []).map((user) => (
        <MenuItem key={`user_${user.id}`} value={user.id} title={user.displayName}>
          {user.displayName}
        </MenuItem>
      ))}
    </Select>
  )
}

export default memo(UsersFilter)

